<template>
  <div class="grid">
    <div class="col-12 p-mt-1 p-mb-1">
        <TabMenu :model="items" />
      </div>
  </div>
</template>
<script>
export default {
  name: 'MailNavBar',
  data () {
    return {
      items: [],
    }
  },
  computed: {
    isLoggedIn: function () { return this.$store.state.auth.status.loggedIn }
  },
  mounted() {
    this.items = [
                //{
                //    label: 'Dashboard',
                //    icon: 'pi pi-fw pi-home',
                //    to: '/',
                //    visible: () => this.isLoggedIn
                //},
                //{
                //    label: 'Domains',
                //    icon: 'pi pi-fw pi-calendar',
                //    to: '/domains',
                //    visible: () => this.isLoggedIn
                //},
                 {
                    label: 'Accounts',
                    icon: 'pi pi-fw pi-user',
                    to: '/domains/' + this.$route.params.domain_id + '/mail/accounts',
                },
                {
                    label: 'Aliases',
                    icon: 'pi pi-fw pi-clone',
                    to: '/domains/' + this.$route.params.domain_id + '/mail/aliases',

                },
                {
                    label: 'Forwards',
                    icon: 'pi pi-fw pi-reply',
                    to: '/domains/' + this.$route.params.domain_id + '/mail/forwards',

                },
                {
                    label: 'Settings',
                    icon: 'pi pi-fw pi-cog',
                    to: '/domains/' + this.$route.params.domain_id + '/mail/settings',

                },
    ]
  },
  methods: {
    async logout () {
      await this.$store.dispatch('auth/logout')
      this.$router.push('/login')
    }
  }
}
</script>
<style>

</style>
